import { SEARCH, HTTP } from '@/utils/http';
import Vue from 'vue';
import * as actionTypes from '../types/actions';
import * as getterTypes from '../types/getters';
import * as mutationTypes from '../types/mutations';

const getters = {
  [getterTypes.GET_EPISODE_COLLECTION]: state => state.collection,
  [getterTypes.GET_EPISODE_COLLECTIONS]: state => state.collections,
  [getterTypes.GET_EPISODE_COLLECTIONS_PAGINATION]: state => state.pagination,
};

const actions = {
  async [actionTypes.DO_GET_EPISODE_COLLECTION]({ commit }, payload) {
    const { id, ...params } = payload;
    const { data } = await HTTP.get(`/episode_collections/${id}`, { params });
    commit(mutationTypes.SET_EPISODE_COLLECTION, data.data.episode_collections[0]);
    return data;
  },
  async [actionTypes.DO_GET_EPISODE_COLLECTIONS]({ commit }, payload) {
    const { method, ...params } = payload;
    const { data } = await SEARCH.post('/doxa_episode_collections/_search', params);
    if (data.hits.total > 0) {
      const mutation = method === 'append' ? mutationTypes.APPEND_EPISODE_COLLECTIONS : mutationTypes.SET_EPISODE_COLLECTIONS;
      commit(mutation, data.hits.hits.map(h => h._source));
      return data;
    }
    commit(mutationTypes.SET_EPISODE_COLLECTIONS, []);
    return data;
  },
};

const mutations = {
  [mutationTypes.APPEND_EPISODE_COLLECTIONS](state, collections) {
    state.collections = state.collections.concat(collections);
  },
  [mutationTypes.SET_EPISODE_COLLECTION](state, collection) {
    state.collection = collection;
  },
  [mutationTypes.SET_EPISODE_COLLECTIONS](state, collections) {
    state.collections = collections;
  },
  [mutationTypes.SET_EPISODE_COLLECTIONS_PAGINATION_FIELD](state, payload) {
    Vue.set(state.pagination, payload.key, payload.val);
  },
};

export default {
  state: {
    collection: {},
    collections: [],
    pagination: {
      page: 1,
      per: 12,
      total: 0,
    },
  },
  getters,
  actions,
  mutations,
};
